import { map } from 'rxjs/operators';

import { CommercialListStore } from './commercial-list.store';

export abstract class CommercialListBaseComponent {
  public list$ = this.componentStore.list$;
  public deliveryInfoLoading$ = this.componentStore.deliveryInfoLoading$;
  public deliveryInfoError$ = this.componentStore.deliveryInfoError$;
  public productReferenceData$ = this.componentStore.productReferenceData$;
  public showCommercialListLoader$ =
    this.componentStore.showCommercialListLoader$;
  public multiplier$ = this.componentStore.multiplier$;
  public multiplierEnabled$ = this.componentStore.multiplierEnabled$;
  public shopTheBasket = this.componentStore.shopTheBasket.bind(
    this.componentStore,
  );
  public multiply = this.componentStore.multiply.bind(this.componentStore);
  public showCommercialListMultiplier$ =
    this.componentStore.showCommercialListMultiplier$;
  public totalAvailableItems$ = this.componentStore.productReferenceData$.pipe(
    map((data) => data?.availableItemTotals.totalRequestedQuantity ?? 0),
  );
  public buttonText$ = this.componentStore.buttonText$;
  public disabled$ = this.componentStore.disabled$;
  public mixedDeliveryDates$ = this.componentStore.mixedDeliveryDates$;
  public singleDeliveryDate$ = this.componentStore.singleDeliveryDate$;
  public hasSizeMissedPrice$ = this.componentStore.hasSizeMissedPrice$;

  protected constructor(public componentStore: CommercialListStore) {}
}
